import React from 'react';
import {
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
} from '@razorpay/blade/components';
import { statesOfIndia } from 'utils/StatesOfIndia';
import { CustomSelectInputProps } from '../types';

export const SelectState = ({
  register,
  formData,
  onChangeSuccess,
  isDisabled,
}: CustomSelectInputProps) => {
  const selectedStateId =
    statesOfIndia.find((s) => s.code.toString() === formData?.state?.[0])?.code || '';

  return (
    <Dropdown selectionType="single" _width="50%">
      <SelectInput
        label="State"
        necessityIndicator="required"
        placeholder="Choose State"
        {...register({ name: 'state', type: 'select', onSuccess: onChangeSuccess })}
        isDisabled={isDisabled}
      />
      <DropdownOverlay>
        <ActionList>
          {statesOfIndia
            .filter((s) => s.esicState)
            .map((state) => (
              <ActionListItem
                key={state.code}
                title={state.name}
                value={state.code.toString()}
                isSelected={selectedStateId === String(state.code)}
              />
            ))}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
